(() => {
  angular.module('app').component('toolkitList', {
    template:'<embedded-container class="absolute" style="overflow-y: hidden" options="ctrl.options" hide-header="true" ng-if="ctrl.options"></embedded-container>',
    controller: Controller,
    controllerAs: 'ctrl',
    bindings: {
      user: '<',
      var: '<',
    },
  });

  Controller.$inject = ['$rootScope', 'LoopBackAuth', '$sce', 'NativeAppIntegration'];

  function Controller($rootScope, LoopBackAuth, $sce, integration) {
    const vm = this;

    vm.$onInit = function () {
      const hostUrl = integration.baseUrl();
      if (hostUrl) {
        // The React host gets the session from embedded-container's handshake,
        // never from the URL.
        const url = new URL(`${hostUrl}/applications`);
        url.searchParams.set('lang', $rootScope.currentLang);
        url.searchParams.set('theme', $rootScope.darkMode ? 'dark' : 'light');
        vm.options = { trustSrc: $sce.trustAsResourceUrl(url.toString()) };
        return;
      }

      const lang = $rootScope.currentLang;
      const accessToken = LoopBackAuth.accessTokenId;
      const userId = vm.user.id;

      let userType = 'Manager';

      if (vm.user.isAdmin) {
        userType = 'Admin';
      }

      if (vm.user.isSupportAdmin) {
        userType = 'SupportAdmin';
      }

      if (vm.user.isSuperAdmin) {
        userType = 'SuperAdmin';
      }

      let src = window.newAppURL ? window.newAppURL : 'http://localhost:5173';

      src += `/applications?tk=${accessToken}&uid=${userId}&ut=${userType}&lang=${lang}`;

      const varId = vm.user.varId || vm.var?.id || null;

      if (varId) {
        src += `&varId=${varId}`;
      }

      src += `&theme=${$rootScope.darkMode ? 'dark' : 'light'}`;

      vm.options = {
        trustSrc: $sce.trustAsResourceUrl(src),
      };
    };
  }
})();
